<div class="cs-navigation-indicator" [style.opacity]="loadingRoute ? '1' : '0'" [style.width.%]="loadProgress"></div>
